import { useCallback, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

// Shared download boilerplate for the report exports: toggles an `isExporting`
// flag around the (synchronous) file build and surfaces a toast on failure.
// Callers pass a producer that builds + saves the file (see ReportExport /
// MetricExportButton).
export const useExportDownload = () => {
  const { t } = useTranslation();
  const [isExporting, setIsExporting] = useState(false);

  const download = useCallback(
    (produce: () => void) => {
      try {
        setIsExporting(true);
        produce();
      } catch {
        toast.error(t('analytics.export_error'));
      } finally {
        setIsExporting(false);
      }
    },
    [t]
  );

  return { isExporting, download };
};
